<div class="col-md-12">
  <div class="ab-cards">
    <div class="ab-card ab-card--wide">
      <a
        *ngIf="noticeCount > 0"
        uiSref="project-errors"
        [uiParams]="{
          projectId: project.id,
          filters: {
            'context.route': routeStats.route,
            'context.httpMethod': routeStats.method,
            'context.environment': routeStats.env,
            start_time: startTime,
            resolved: 'any'
          }
        }"
        >Error occurrences</a
      ><span *ngIf="noticeCount === 0">Error occurrences</span>
      <h1 class="ab-card__data" *ngIf="!loading">
        {{ noticeCount | numberToHuman }}
      </h1>
      <div *ngIf="loading">
        <ab-spinner-inline></ab-spinner-inline>
      </div>
    </div>
    <div class="ab-card ab-card--wide">
      <a
        *ngIf="groups.count > 0"
        uiSref="project-errors"
        [uiParams]="{
          projectId: project.id,
          filters: {
            'context.route': routeStats.route,
            'context.httpMethod': routeStats.method,
            'context.environment': routeStats.env,
            start_time: startTime,
            resolved: 'any'
          }
        }"
        >Total errors</a
      ><span *ngIf="groups.count === 0">Total errors</span>
      <h1 class="ab-card__data" *ngIf="!loading">{{ groups.count }}</h1>
      <div *ngIf="loading">
        <ab-spinner-inline></ab-spinner-inline>
      </div>
    </div>
    <div class="ab-card ab-card--wide">
      <a
        *ngIf="unresolvedGroupCount > 0"
        uiSref="project-errors"
        [uiParams]="{
          projectId: project.id,
          filters: {
            'context.route': routeStats.route,
            'context.httpMethod': routeStats.method,
            'context.environment': routeStats.env,
            start_time: startTime,
            resolved: 'false'
          }
        }"
        >Unresolved errors</a
      ><span *ngIf="unresolvedGroupCount === 0">Unresolved errors</span>
      <h1 class="ab-card__data" *ngIf="!loading">{{ unresolvedGroupCount }}</h1>
      <div *ngIf="loading">
        <ab-spinner-inline></ab-spinner-inline>
      </div>
    </div>
    <div class="ab-card ab-card--wide">
      <a
        *ngIf="resolvedGroupCount > 0"
        uiSref="project-errors"
        [uiParams]="{
          projectId: project.id,
          filters: {
            'context.route': routeStats.route,
            'context.httpMethod': routeStats.method,
            'context.environment': routeStats.env,
            start_time: startTime,
            resolved: 'true'
          }
        }"
        >Resolved errors</a
      ><span *ngIf="resolvedGroupCount === 0">Resolved errors</span>
      <h1 class="ab-card__data" *ngIf="!loading">{{ resolvedGroupCount }}</h1>
      <div *ngIf="loading">
        <ab-spinner-inline></ab-spinner-inline>
      </div>
    </div>
  </div>
</div>
